module.exports = __webpack_public_path__ + "static/img/bg222png.5d6629e8.png";